import { useCallback } from 'react';
import {
  ErisCSVStatusExportRequestBody,
  ErisCSVSummaryExportRequestBody,
} from '../service/hepler/ErisCSVRequestBody';
import {
  ErisStatusResultsModel,
  ErisStatusSearchingParameters,
  ErisSummaryModel,
} from '../store/ErisInformationStore';
import { partialErisStatusSearchingParameters } from './common/partialSearchingParameters';
import useErisApi from './axios/useErisApi';

function useWorkplacesRepo() {
  const { get, post } = useErisApi();

  const getGroupStatus = useCallback(
    async (searchParameters: ErisStatusSearchingParameters) =>
      await post<ErisStatusResultsModel>(
        'api/er/workplaces/statuses/search',
        partialErisStatusSearchingParameters(searchParameters, [
          'searchParams',
          'pageNumber',
          'pageSize',
        ])
      ),
    [post]
  );

  const getGroupSummary = useCallback(
    async (searchParameters: ErisStatusSearchingParameters) =>
      await get<ErisSummaryModel>('api/er/workplaces/summaries', {
        params: partialErisStatusSearchingParameters(searchParameters, ['groupName', 'userId']),
      }),
    [get]
  );

  const getGroupStatusCSV = useCallback(
    async (searchParameters: ErisCSVStatusExportRequestBody) =>
      await post<Blob>('api/er/workplaces/statuses/csv/export', searchParameters, {
        responseType: 'blob',
        headers: { Accept: 'text/csv' },
      }),
    [post]
  );

  const getGroupSummaryCSV = useCallback(
    async (searchParameters: ErisCSVSummaryExportRequestBody) =>
      await post<Blob>('api/er/workplaces/summaries/csv/export', searchParameters, {
        responseType: 'blob',
        headers: { Accept: 'text/csv' },
      }),
    [post]
  );

  return { getGroupStatus, getGroupSummary, getGroupStatusCSV, getGroupSummaryCSV };
}

export default useWorkplacesRepo;
